
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Articulo } from '@/__env/lib/Articulos';
    import actual from './estadisticas-articulo-actual.vue';
    import ventas from './estadisticas-articulo-ventas.vue';
    import mas from './estadisticas-articulo-mas.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            actual,
            ventas,
            mas,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public tab: string = '';
        public Estado: 'ok' | 'cargando' = 'cargando';
        Articulo: Articulo = new Articulo();

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async mounted()
        {
            this.Eventos.push( this.Controlador.onActualizarFavoritos.subscribe( () => this.Refrescar() ) );
            this.Articulo = this.Controlador.ArticuloSeleccionado;
            this.Estado = "ok";
        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => { this.Refresh = true; } );
        }

    }
